/** Centralized username validation for the client. Mirrors DB constraints + reserved list. */

export const RESERVED_USERNAMES = [
  "aelyra","aelyrasolari","caelion","caelionveyr","vaelor","headmastervaelor",
  "heirwise","admin","administrator","support","founder","system","teacher",
  "guide","luminar","luminara","moderator","mod","staff","owner","root",
  "official","help","contact","security","billing","payments","stripe",
  "computer","bot","ai","aitutor",
];

export type UsernameError =
  | "empty"
  | "too_short"
  | "too_long"
  | "invalid_chars"
  | "edge_dot"
  | "double_dot"
  | "reserved";

export type UsernameValidation =
  | { ok: true }
  | { ok: false; reason: UsernameError; message: string };

export function validateUsername(input: string): UsernameValidation {
  const u = (input ?? "").trim();
  if (!u) return { ok: false, reason: "empty", message: "Username is required." };
  if (u.length < 3) return { ok: false, reason: "too_short", message: "Username must be at least 3 characters." };
  if (u.length > 20) return { ok: false, reason: "too_long", message: "Username must be at most 20 characters." };
  if (!/^[a-zA-Z0-9_.]+$/.test(u))
    return { ok: false, reason: "invalid_chars", message: "Only letters, numbers, underscores, and periods are allowed." };
  if (u.startsWith(".") || u.endsWith("."))
    return { ok: false, reason: "edge_dot", message: "Username can't start or end with a period." };
  if (u.includes(".."))
    return { ok: false, reason: "double_dot", message: "Username can't contain consecutive periods." };
  if (RESERVED_USERNAMES.includes(u.toLowerCase()))
    return { ok: false, reason: "reserved", message: "That username is reserved. Please choose another." };
  return { ok: true };
}

/** Display helper: prefers username, falls back through display_name / first name / email prefix. */
export function displayUsername(opts: {
  username?: string | null;
  display_name?: string | null;
  first_name?: string | null;
  email?: string | null;
}): string {
  if (opts.username) return `@${opts.username}`;
  if (opts.display_name) return opts.display_name;
  if (opts.first_name) return opts.first_name;
  if (opts.email) return opts.email.split("@")[0];
  return "Learner";
}